import React, {useState} from 'react'
import {FormControl, InputAdornment, TextField} from '@mui/material'
import {ITextInput} from './interfaces';
import {TextInputFlex, TextInputFullWidth, TextInputSearchIcon} from './styles';


const TextInput = (props: ITextInput) => {
  const {
    name = "",
    label = "",
    value = "",
    type = 'text',
    inputProps = {},
    placeholder = "",
    onChange,
    onKeyDown,
    fullWidth = true,
  } = props;

  const [textValue, setTextValue] = useState<string>(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(event.target.value);
    onChange && onChange(event);
  }

  return (
    <TextInputFlex item>
      <TextInputFullWidth item>
        <FormControl variant='standard' fullWidth>
          <TextField
            variant="standard"
            type={type || "text"}
            InputLabelProps={{
              shrink: true,
            }}
            name={name}
            value={textValue}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <TextInputSearchIcon fontSize='medium' />
                </InputAdornment>
              ),
              ...inputProps
            }}
            fullWidth={fullWidth}
            label={label}
            sx={{
              '& input::placeholder': {
                fontSize: '1em'
              }
            }}
          />
        </FormControl>
      </TextInputFullWidth>
    </TextInputFlex>
  )
}

export default TextInput
